<template>
  <nav class="navbar">
    <div class="container-fluid">
      <a class="navbar-brand">
        <img class="img-fluid" src="../assets/logo.svg" alt="" @click="goHome">
      </a>

      <div class="d-flex align-items-center">
        <div v-if="headerButton === 'my-account'">
          <a role="button" class="header-btn" @click="doAccount">
            <svg class="account-svg bi bi-person-fill" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
            </svg>
            My Account
          </a>
        </div>
        <div v-else-if="headerButton !== 'none'">
          <div v-if="isSignedIn">
            <a role="button" class="header-btn" @click="doSignOut">Sign Out</a>
          </div>
          <div v-else>
            <a role="button" class="header-btn" @click="doSignIn">Sign In</a>
          </div>
        </div>
      </div>
    </div>
  </nav>
  <div v-if="backTo" class="back-link-bar">
    <a role="button" class="back-link" @click="goBack">&#8592; Back to {{ backTo.label }}</a>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import AuthService from "@/services/auth-service";

export default defineComponent({
  name: 'Header',
  props: {
    hideBack: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      pageName: ''
    }
  },
  created() {
    this.pageName = this.$route.meta.pageName
  },
  methods: {
    doSignIn () {
      this.$router.push('/signin')
    },
    goHome () {
      this.$router.push('/')
    },
    goBack () {
      this.$router.push(this.backTo.path)
    },
    doAccount () {
      this.$router.push('/account')
    },
    doSignOut () {
      AuthService.signOut().then(() => {
        this.$router.push('/signin')
      })
    },
  },
  computed: {
    isSignedIn () {
      return AuthService.isSignedIn()
    },
    headerButton () {
      return this.$route.meta.headerButton || 'default'
    },
    backTo () {
      if (this.hideBack) return null;
      return this.$route.meta.backTo || null
    }
  }
})
</script>

<style>
@import '../assets/style.css';
</style>
